<template>
    <div class="card mb-4">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col d-flex align-items-center">
                    <h2 class="card-title mb-0">Basic Details</h2>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-link" v-c-modal:detailsModal="{}">
                        <i class="far fa-pencil-alt"></i> Edit
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <p>
                        <span class="data-label">Legal Company Name</span>
                        {{ client.company }}
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <p>
                        <span class="data-label">Display Name</span>
                        {{ client.display_name ? client.display_name : '-' }}
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <p class="text-truncate">
                        <span class="data-label">Primary Contact</span>
                        <template v-if="client.primary_contact">
                            {{ client.primary_contact.name }} <small class="text-muted">{{ client.primary_contact.email }}</small>
                        </template>
                        <template v-else>-</template>
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <p>
                        <span class="data-label">Phone</span>
                        {{ client.phone ? client.phone : '-' }}
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <p class="text-truncate">
                        <span class="data-label">Website</span>
                        <a v-if="client.website" :href="client.website" target="_blank" rel="noopener">{{ client.website }}</a>
                        <template v-else>-</template>
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <p>
                        <span class="data-label">Default Project Agreement</span>
                        {{ client.project_agreement ? client.project_agreement.title : '-' }}
                    </p>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <span class="data-label">Xero</span>
                    <p v-if="client.xero_id">
                        <a :href="'https://go.xero.com/Contacts/View/' + client.xero_id" target="_blank" rel="noopener">
                            View in Xero <i class="fal fa-external-link-alt"></i>
                        </a>
                    </p>
                    <c-button v-else @click="createInXero" class="btn btn-sm btn-rounded btn-primary">Create in Xero</c-button>
                </div>
            </div>
        </div>

        <client-details-modal ref="detailsModal" :client="client" />
    </div>
</template>

<script>
import { http, notify } from 'utils'
import { helperMethods } from 'vx/modules/clients'
import ClientDetailsModal from './ClientDetailsModal'

export default {
    props: ['client'],

    components: {
        ClientDetailsModal
    },

    methods: {
        ...helperMethods,

        createInXero () {
            return http.post(`/clients/${this.client.id}/xero`).then(() => {
                //Refresh the client so the returned xero_id is reflected in the UI.
                return this.getClient(this.client.id)
            }).catch((error) => {
                const message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Failed to create client in Xero, please try again.'

                notify.error(message)

                return Promise.reject(error)
            })
        }
    }
};
</script>
